import { render, staticRenderFns } from "./FeaturedMedia.vue?vue&type=template&id=249bd2b8&scoped=true&"
import script from "./FeaturedMedia.vue?vue&type=script&lang=js&"
export * from "./FeaturedMedia.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedMedia.vue?vue&type=style&index=0&id=249bd2b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249bd2b8",
  null
  
)

export default component.exports